<template>
<!-- eslint-disable max-len -->
<list-page
  name="Dashboard Profile"
  use="_id"
  :display="display"
  page-prefix="/blade/dashboards/profiles"
  :fetch="getDashboardProfiles"
  :remove="deleteDashboardProfile"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getDashboardProfiles',
      'deleteDashboardProfile'
    ]),
    display({ name: profileName, updated }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${profileName} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/components/dashboards/pages/DashboardProfileList.vue